import { NgModule } from '@angular/core';
import { ActivatedRouteSnapshot, RouterModule } from '@angular/router';

/* @Injectable({ providedIn: 'root' })
export class SmallBusinessResolver implements Resolve<string> {

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): string | Observable<string> | Promise<string> {
    return route.params.id ? route.params.id : 'pec';
  }
  
}*/

/**
 * Angular Module that define all the application's parent pages
 */
@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: ':id/security',
        resolve: {
          smallBusiness: 'currentSmallBusiness',
        },
        loadChildren: () => import('./security/security.module').then(m => m.SecurityModule),
      },
    ]),
  ],
  providers: [
    {
      provide: 'currentSmallBusiness',
      useValue: (route: ActivatedRouteSnapshot) => (route.params.id ? route.params.id : 'pec'),
    },
  ],
})
export class AccountPanelPagesModule {}
